export function isPointInPolygon (latitude, longitude, polygon) {
    if (typeof latitude !== 'number' || typeof longitude !== 'number') {
      return false;//throw new TypeError('Invalid latitude or longitude. Numbers are expected')
    } else if (!polygon || !Array.isArray(polygon)) {
      return false;//throw new TypeError('Invalid polygon. Array with locations expected')
    } else if (polygon.length === 0) {
      return false;//throw new TypeError('Invalid polygon. Non-empty Array expected')
    }

    const x = latitude; const y = longitude

    let inside = false
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i].Latitude; const yi = polygon[i].Longitude
      const xj = polygon[j].Latitude; const yj = polygon[j].Longitude

      const intersect = ((yi > y) !== (yj > y)) &&
              (x < (xj - xi) * (y - yi) / (yj - yi) + xi)
      if (intersect) inside = !inside
    }

    return inside
}

export function isValidLatLng(latitude: number, longitude: number): boolean {
    // const reg = new RegExp("^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,6}");
    const reg = new RegExp("^-?([0-9]{1,2}|1[0-7][0-9]|180)(\.[0-9]{1,10})$");

    const lat = latitude?.toString()||"";
    const lng = longitude?.toString()||"";

    if(reg.exec(lat) && reg.exec(lng)) {
        return true;
    }

    return false;
}
